import { render, staticRenderFns } from "./EditFormationPage.vue?vue&type=template&id=0797f591"
import script from "./EditFormationPage.vue?vue&type=script&lang=js"
export * from "./EditFormationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports